import api from "./axios";

/**
 * Inviting people to Mintly. @see mintly-back/src/routes/referralRoutes
 */

/** My invite link, the share in force, and the people I've invited. */
export const getMyReferrals = async () => {
  try {
    const response = await api.get("/referrals/me");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Attach my brand-new account to whoever's link I came through. For Google and
 * Facebook sign-ups — an email sign-up sends the code with the form.
 */
export const claimReferral = async (code) => {
  const response = await api.post("/referrals/claim", { code });
  return response.data;
};
